import styled from "styled-components"
import { TripleGrid } from "../../Global"

export const Description = styled.p`
  font-size: 16px;
`
export const VideosGrid = styled(TripleGrid)`
  gap: 20px;
`
